import React from 'react';

import './App.css';
import Layout from './Layout';
import Seo from './component/Seo';
import Service from './component/ServiceSection';
import Main from './component/MainSection';
import Faq from './component/FaqSection';
import Contact from './component/ContactSection';
import Gallery from './component/GallerySection';

const SEO = {
  lt: {
    title: 'Tralo paslaugos Kaune ir visoje Lietuvoje 24/7 | Geltonas Traliukas',
    description: 'Pigios ir kokybiškos tralo paslaugos Kaune ir visoje Lietuvoje 24/7. Greita pagalba kelyje, avarinė pagalba, automobilių pervežimas.'
  },
  en: {
    title: 'Tow truck services in Kaunas and Lithuania 24/7 | Geltonas Traliukas',
    description: 'Affordable tow truck services in Kaunas and throughout Lithuania, 24/7. Roadside assistance, emergency help, vehicle transport.'
  },
  ru: {
    title: 'Услуги эвакуатора в Каунасе и по всей Литве 24/7 | Geltonas Traliukas',
    description: 'Недорогие услуги эвакуатора в Каунасе и по всей Литве 24/7. Помощь на дороге, аварийная помощь, перевозка автомобилей.'
  }
};

function App({ lang = 'lt' }) {
  return (
    <Layout
      lang={lang}
      renderChildren={({ strings, pageWidth, onTop }) => (
        <>
          <Seo path="/" lang={lang} title={SEO[lang].title} description={SEO[lang].description} />
          <Main strings={strings} pageWidth={pageWidth} onTop={onTop} />
          <Service strings={strings} onTop={onTop} pageWidth={pageWidth} section="light" lang={lang} />
          <Faq strings={strings} onTop={onTop} pageWidth={pageWidth} section="dark" />
          <Gallery strings={strings} onTop={onTop} pageWidth={pageWidth} section="light" />
          <Contact strings={strings} onTop={onTop} pageWidth={pageWidth} section="dark" />
        </>
      )}
    />
  );
}

export default App;
